import { createAsyncThunk, createReducer, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

//create slice
const name = "dashboard";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers= (builder) => {
  createExtraReducers(builder);
}
const slice = createSlice({ name, initialState, reducers, extraReducers });

//exports
export const dashboardActions = { ...slice.actions, ...extraActions };
export const dashboardReducer = slice.reducer;

//implementation
function createInitialState() {
  return {
    dashboardList: [],
    orderDashboardList: [],
    error: null,
    dashboardResponse: [],
    OrderPrice: {},
    isLoading: false,
  };
}

function createReducers() {
  return {
    cleardashboardResponse,
  };

  function cleardashboardResponse(state) {
    state.orderDashboardList = [];
    state.dashboardList = [];
    state.OrderPrice = {};
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/Dashboard`;

  return {
    getDashboardList: getDashboardList(),
    getOrderDashboard: getOrderDashboard(),
    getOrderPrice: getOrderPrice(),
  };

  function getDashboardList() {
    return createAsyncThunk(
      `${name}/getDashboardList`,
      async () => await fetchWrapper.get(`${baseUrl}/GetMainDashboard`)
    );
  }

  function getOrderDashboard() {
    return createAsyncThunk(
      `${name}/getOrderDashboard`,
      async () => await fetchWrapper.get(`${baseUrl}/GetOrderDashboard`)
    );
  }

  function getOrderPrice() {
    return createAsyncThunk(
      `${name}/getOrderPrice`,
      async () => await fetchWrapper.get(`${baseUrl}/GetOrderPriceDashboard`)
    );
  }
}

function createExtraReducers(builder) {
  builder
      .addCase(extraActions.getDashboardList.pending, (state) => {
          state.isLoading = false;
          state.dashboardList = [];
      })
      .addCase(extraActions.getDashboardList.fulfilled, (state, action) => {
          state.isLoading = true;
          state.dashboardList = action.payload || [];
          state.dashboardResponse = [];
      })
      .addCase(extraActions.getDashboardList.rejected, (state) => {
          state.isLoading = true;
          state.dashboardList = [];
      })
      .addCase(extraActions.getOrderDashboard.pending, (state) => {
          state.isLoading = false;
          state.orderDashboardList = [];
      })
      .addCase(extraActions.getOrderDashboard.fulfilled, (state, action) => {
          state.isLoading = true;
          state.orderDashboardList = action.payload || [];
          state.dashboardList = [];
      })
      .addCase(extraActions.getOrderDashboard.rejected, (state) => {
          state.isLoading = true;
          state.orderDashboardList = [];
      })
      .addCase(extraActions.getOrderPrice.pending, (state) => {
          state.OrderPrice = { loading: true };
      })
      .addCase(extraActions.getOrderPrice.fulfilled, (state, action) => {
          state.OrderPrice = action.payload || {};
      })
      .addCase(extraActions.getOrderPrice.rejected, (state, action) => {
          state.OrderPrice = { error: action.error };
      });
}
